import { Drawer as CDrawer, DrawerProps as CDrawerProps } from '@chakra-ui/react'

export function Drawer({ closeOnOverlayClick = false, ...props }: CDrawerProps) {
  return <CDrawer closeOnOverlayClick={closeOnOverlayClick} {...props} />
}
